import { NAVIGATE_INDEX, NAVIGATE_TO_CLAIMENT_DETAILS, NAVIGATE_TO_DECEASED_DETAILS, NAVIGATE_TO_SUCCESS, NAVIGATE_TO_UPLOAD_DOCUMENTS, PROGRESS_BAR_TRANSITION, SET_ACTIVE_PAGE_INDEX, SET_NAVIGATION_DONE } from "../../actions/sizotsaFuneralClaim/routing";
import { PROGRESS_BAR_STEPS, SZ_CLAIM_PAGE_INDICES } from "../../actions/sizotsaFuneralClaim/types";


export const initRouting = {
  activePageIndex: 0,
  progressBarSteps: PROGRESS_BAR_STEPS,
  doNavigation: false,
  doExitNavigation: false,
  parentAppUrl: null,
  callbackAction: null,
  parentApp: null,
};

export default (state = initRouting, action) => {
  const setActivePage = (pageIndex) => ({
    ...state,
    activePageIndex: pageIndex,
    doNavigation: true,
  });

  switch (action.type) {
    case NAVIGATE_INDEX:
      return {
        ...state,
        activePageIndex: action.value,
      };

    case SET_ACTIVE_PAGE_INDEX:
      return {
        ...state,
        doNavigation: true,
        activePageIndex: action.value,
      };

    case SET_NAVIGATION_DONE:
      return { ...state, doNavigation: false };

    case NAVIGATE_TO_CLAIMENT_DETAILS:
      return setActivePage(SZ_CLAIM_PAGE_INDICES.CLAIMENT_DETAILS);

    case NAVIGATE_TO_DECEASED_DETAILS:
      return setActivePage(SZ_CLAIM_PAGE_INDICES.DECEASED_DETAILS);

    case NAVIGATE_TO_UPLOAD_DOCUMENTS:
      return setActivePage(SZ_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS);

    case NAVIGATE_TO_SUCCESS:
      return setActivePage(SZ_CLAIM_PAGE_INDICES.SUCCESS_PAGE);

    case PROGRESS_BAR_TRANSITION:
      const  updatedSteps=PROGRESS_BAR_STEPS.map((step,index)=>index<=action.value?{...step,isActive:true,isCompleted:true}:step)
      return {
        ...state,
        progressBarSteps:updatedSteps
      }
    
    default:
      return state;
  }
};
